import { getProfile } from './localStorage';
import { hasPermission } from './timeTracking';

/**
 * ซ่อนปุ่มตามสิทธิ์ (create / update / delete ฯลฯ)
 * super_user / admin-company เห็นทุกปุ่ม และพอร์ทัลดูอย่างเดียวเหลือแค่ .read เหมือน PermissionRoute
 * ปุ่มที่ซ่อนแล้ว backend ยังตรวจสิทธิ์ซ้ำเสมอ (403 -> alert ไม่มีสิทธิ์ใช้งาน)
 */
export const can = (key) => hasPermission(getProfile(), key);

/** ผ่านถ้ามีอย่างน้อยหนึ่ง key */
export const canAny = (...keys) => keys.flat().some((key) => can(key));
